import { combineReducers } from 'redux';

import * as actions from '../actions';

function byId(state = {}, action) {
  switch (action.type) {
    case actions.CREATE_TECHDOC_SUCCESS:
    case actions.REQUEST_TECHDOC_SUCCESS:
      return Object.assign({}, state, action.data.response.entities.businessInformationTemplates);
    case actions.REQUEST_BUSINESSINFO_ORDER_SUCCESS:
    case actions.UPDATE_BUSINESSINFO_NOTES_SUCCESS:
      return Object.assign({}, state, action.data.entities.businessInformationTemplates);
    default:
      return Object.assign({}, state);
  }
}

const businessInformationTemplates = combineReducers({
  byId,
});

export default businessInformationTemplates;

export const getBITemplateById = (state, id) =>
  Object.assign({}, state.businessInformationTemplates.byId[id]);
